export default {
  currentStudyId: null,
  completion: null,
  completionParticipant: null,
  siteListInParticipants: [],
  eConsentRawData: null,
  eConsentDispositionData: null,
  consentBlocks: null,

  complianceWidgets: [],
  specificSiteId: [],
  dataLoaded: false,
  visConsentDisposition: null,

  filterTriggered: false,

  countryList: [],
  allSitesList: [],
  participantRaws: [],
  participantList: [],
  sitesSelected: ["all"],
  participantsSelected: ["all"],
  countrySelected: ["all"],
  fromDate: "", // YYYY-MM-DD
  toDate: "", //YYYY-MM-DD
  // ignore cached data and make api call
  ignoreCache: false
}